import { IsNotEmpty, IsString } from "class-validator";


export class CreateItemconfigurationDto {
    @IsString()
    item: string;

    @IsNotEmpty()
    image: string;
    @IsNotEmpty()
    uid: string;
    @IsNotEmpty()
    mimetype: string;
    @IsNotEmpty()
    originalname: string;
    @IsNotEmpty()
    size: number;

}
